import { Row, Col, Typography, Card } from "antd";
import AppFooter from "../../constants/layout/footer";
import { Link } from "react-router-dom";
import { LoginContainer } from "../../components";

const { Text } = Typography;

const Privacy = () => {
    return (
        <LoginContainer>
            <Row justify="center" align="middle">
                <Card style={{ width: "90%" }}>
                    <Row style={{ marginTop: "2em" }}>
                        <Col span={4}></Col>
                        <Col span={16}>
                            ø
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                <Text style={{ fontSize: "2.5em", fontWeight: "bolder" }}>
                                    Appbox Privacy Policy
                                </Text>
                            </Row>
                            <Row
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginBottom: "1em",
                                }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: "lighter" }}>
                                    Last Modified: October 4, 2023
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Welcome and thank you for your interest in Appbox Di Cama
                                    Claudio (”Appbox”, ”we”, ”our”, or ”us”). This Privacy Policy
                                    explains how information that identifies or is associated with
                                    you (your ”personal information”) is collected, used, and
                                    disclosed by Appbox. This Privacy Policy applies to our websites
                                    including
                                    <a href="https://appbox.cloud"> https://appbox.cloud</a> and any
                                    other website that links to this Policy (our ”Sites”)
                                    (collectively, our ”Service”). Before accessing or using our
                                    Service, please ensure that you have read, and understood our
                                    collection, storage, use, and disclosure of your personal
                                    information as described in this Privacy Policy and our{" "}
                                    <Link to={"/terms_of_service"}> Terms of Service </Link> .
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    What Information Do We Collect and For What Purpose?
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    The categories of information we collect can include:
                                    Information you provide to us directly. We may collect personal
                                    information, such as your name, email address, and payment
                                    information, when you register for our Service, sign up for our
                                    mailing list, or otherwise communicate with us. We may also
                                    collect any communications between you and Appbox and any other
                                    information you provide to Appbox. Data collected through the
                                    use of the Service. We collect information about how you use the
                                    Service, your actions on the Service, and content you post to
                                    the Service (”User Content”), namely to improve the Service
                                    generally, to monitor and resolve issues, and for other internal
                                    purposes. Please remember that Appbox may, but has no obligation
                                    to, monitor, record, and store User Content in order to protect
                                    your safety or the safety of other users, to assist with
                                    regulatory or law enforcement efforts, or to protect and defend
                                    our rights and property. Information we receive from third-party
                                    sites you connect to our Service. We may receive personal
                                    information about you from third parties and combine that with
                                    information we collect through our Service. For example, we may
                                    obtain information when you log in through a third-party
                                    provider, such as Google or Github. These services will
                                    authenticate your identity and may provide you the option to
                                    share certain personal information with us, which could include
                                    your name, email address, or other information. Similarly, when
                                    you interact with us through a social media site or third-party
                                    service, such as when you like, follow, share, or otherwise
                                    engage with Appbox content on Facebook, Twitter, GitHub, Slack,
                                    LinkedIn, or other sites, we may receive information from the
                                    social network, including your profile information, picture,
                                    user ID associated with your social media account, and any other
                                    information you permit the social network to share with third
                                    parties. The data we receive from these third-party sites is
                                    dependent upon that third party’s policies and your privacy
                                    settings on that third-party site. You should always review and,
                                    if necessary, adjust your privacy settings on third-party
                                    websites and services before linking or connecting them to our
                                    Service. Location information. We may approximate your location
                                    by your IP Address. Information we receive from third parties.
                                    From time to time, we may receive information about you from
                                    third parties and other users. We may also collect information
                                    about you that is publicly available. We use this information to
                                    operate, maintain, and provide to you the features and
                                    functionality of the Service, as well as to communicate directly
                                    with you, such as to send you email messages, including
                                    promotional messages, and permit you to communicate with others
                                    on the Service or on social media, or invite others to join the
                                    Service. We may also send you Service-related emails or messages
                                    (e.g., account verification, updates to features of the Service,
                                    technical and security notices). We may also use this
                                    information for any other lawful, legitimate business purpose.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    Sharing of Your Information
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    We may share your personal information in the instances
                                    described below. We may share your personal information with:
                                    The public and other members of the Service. Content you post to
                                    public areas of the Service will be viewable by others on the
                                    Service and the public. Please do not provide personal
                                    information you would not want to be public; Third parties at
                                    your request. For example, you may have the option to share your
                                    account on the Service with third parties upon your request;
                                    Third-party vendors and other service providers. We share your
                                    information with third-party vendors and service providers that
                                    perform services on our behalf, as needed to carry out their
                                    work for us, which may include identifying and serving targeted
                                    advertisements; providing emailing services; providing tax,
                                    billing, and accounting services; cloud or web hosting;
                                    providing analytics services; or identifying and understanding
                                    prospects or leads; The public when you provide feedback on our
                                    Service. For example, if you post User Content on our website or
                                    comment on our social media sites, your information, such as
                                    your first name, last initial, state of residence, and your
                                    comments, may be displayed on our Service or on our social media
                                    pages; Business Transfers. We may share your information with
                                    other parties in connection with a company transaction, such as
                                    a merger, sale of company assets or shares, reorganization,
                                    financing, change of control or acquisition of all or a portion
                                    of our business by another company or third party, or in the
                                    event of a bankruptcy or related or similar proceedings; Our
                                    Brands. When you provide personal information to one of our
                                    Appbox brands, we may share that information with other
                                    companies and brands owned or controlled by Appbox, and other
                                    companies owned by or under common ownership as Appbox, which
                                    also includes our subsidiaries (i.e., any organization we own or
                                    control) or our ultimate holding company (i.e., any organization
                                    that owns or controls us) and any subsidiaries it owns. These
                                    companies will use your personal information in the same way as
                                    we can under this Privacy Policy. Regulatory or Legal
                                    Requirements, Safety and Terms Enforcement. Third parties as
                                    required by law or subpoena or if we reasonably believe that
                                    such action is necessary to (a) comply with the law and the
                                    reasonable requests of law enforcement; (b) to enforce our Terms
                                    of Service or to protect the security or integrity of our
                                    Service; and/or (c) to exercise or protect the rights, property,
                                    or personal safety of Appbox, our visitors, or others. We may
                                    also share information with others in an aggregated or otherwise
                                    anonymized form that does not reasonably identify you directly
                                    as an individual.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    How We Use Cookies and Other Tracking Technology to Collect
                                    Information
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    We and our third-party service providers may collect certain
                                    types of usage information when you use our Service, read our
                                    emails, or otherwise engage with us. We use this information to
                                    enhance and personalize your user experience, to recognize and
                                    contact you, and to monitor and improve our websites and
                                    Service. In some instances, we and our third-party service
                                    providers may combine this usage information with personal
                                    information. If we do combine any usage information with
                                    personal information, the combined information will be treated
                                    by us as personal information hereunder (as long as it is so
                                    combined). We typically collect this information through a
                                    variety of tracking technologies, including cookies, Flash
                                    objects, web beacons, embedded scripts, location-identifying
                                    technologies, file information, and similar technology
                                    (collectively, ”tracking technologies”). We, and our third-party
                                    partners, use tracking technologies to automatically collect
                                    usage and device information, such as: Information about your
                                    device and its software, such as your IP address, browser type,
                                    Internet service provider, device type/model/manufacturer,
                                    operating system, date and time stamp, and a unique ID that
                                    allows us to uniquely identify your browser, mobile device, or
                                    your account (including, for example, a persistent device
                                    identifier or an Ad ID), and other such information. We may also
                                    work with third-party partners to employ technologies, including
                                    the application of statistical modeling tools, which permit us
                                    to recognize and contact you across multiple devices.
                                    Information about the way you access and use our Service, for
                                    example, the site from which you came and the site to which you
                                    are going when you leave our Service, the pages you visit, the
                                    links you click, whether you open emails or click the links
                                    contained in emails, whether you access the Service from
                                    multiple devices, and other actions you take on the Service.
                                    Information about your location, including GPS coordinates
                                    (e.g., latitude and/or longitude) or similar information
                                    regarding the location of your mobile device, or we may be able
                                    to approximate or infer a device’s location by analyzing other
                                    information, like an IP address. Analytics information. We may
                                    collect analytics data or use third-party analytics tools such
                                    as Google Analytics to help us measure traffic and usage trends
                                    for the Service and to understand more about the demographics of
                                    our users. You can learn more about Google’s practices at
                                    <a href="https://www.google.com/policies/privacy/partners">
                                        https://www.google.com/policies/privacy/partners
                                    </a>{" "}
                                    and view its currently available opt-out options at
                                    <a href="https://tools.google.com/dlpage/gaoptout">
                                        {" "}
                                        https://tools.google.com/dlpage/gaoptout
                                    </a>
                                    . We also use pixel tags to collect IP addresses, which may then
                                    be used to derive insights from web traffic. If you would prefer
                                    not to accept cookies, most browsers will allow you to: (i)
                                    change your browser settings to notify you when you receive a
                                    cookie, which lets you choose whether or not to accept it; (ii)
                                    disable existing cookies; or (iii) set your browser to
                                    automatically reject cookies; however, doing so may negatively
                                    impact your experience using the Service, as some features and
                                    services on our Service may not work properly. You may also set
                                    your email options to prevent the automatic downloading of
                                    images that may contain technologies that would allow us to know
                                    whether you have accessed our email and performed certain
                                    functions with it. We and our third-party partners may also use
                                    tracking technologies for advertising purposes. For more
                                    information about tracking technologies, please see ”Third-Party
                                    Tracking and Online Advertising” below. How We Respond to Do Not
                                    Track Signals. Although we do our best to honor the privacy
                                    preferences of our users, we are unable to respond to Do Not
                                    Track signals set by your browser at this time.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    Third-Party Tracking and Online Advertising
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Interest-Based Advertising. We participate in interest-based
                                    advertising and use third-party advertising companies to serve
                                    you targeted advertisements based on your browsing history. We
                                    may share or we may permit third-party online advertising
                                    networks, social media companies, and other third-party services
                                    to collect information about your use of our website over time
                                    so that they may display ads on our Service, on other devices
                                    you may use, and on other websites, apps, or services, including
                                    on Facebook. Typically, though not always, the information we
                                    share is provided through cookies or similar tracking
                                    technologies, which recognize the device you are using and
                                    collect information, including click stream information, browser
                                    type, time and date you visited the site, and other information.
                                    We and our third-party partners use this information to make the
                                    advertisements you see online more relevant to your interests,
                                    as well as to provide advertising-related services such as
                                    reporting, attribution, analytics, and market research. Social
                                    Media Widgets and Advertising. Our Service may include social
                                    media features, such as the Facebook Like button, Google Plus,
                                    LinkedIn, Instagram, Twitter, or other widgets. These social
                                    media companies may recognize you and collect information about
                                    your visit to our Service, and they may set a cookie or employ
                                    other tracking technologies. Your interactions with those
                                    features are governed by the privacy policies of those
                                    companies. We display targeted advertising to you through social
                                    media platforms, such as Facebook, Twitter, Google, and others.
                                    These companies have interest-based advertising programs that
                                    allow us to direct advertisements to users who have shown
                                    interest in our Service while those users are on the social
                                    media platform or to groups of other users who share similar
                                    traits, such as likely commercial interests and demographics.
                                    These advertisements are governed by the privacy policies of
                                    those social media companies that provide them. Cross-Device
                                    Linking. We, or our third-party partners, may link your various
                                    devices so that content you see on one device can result in
                                    relevant advertising on another device. We do this by collecting
                                    information about each device you use when you are logged in to
                                    our Service. We may also work with third-party partners who
                                    employ tracking technologies or the application of statistical
                                    modeling tools to determine if two or more devices are linked to
                                    a single user or household. We may share a common account
                                    identifier (such as an email address or user ID) with
                                    third-party advertising partners to help recognize you across
                                    devices. We, and our partners, can use this cross-device linkage
                                    to serve interest-based advertising and other personalized
                                    content to you across your devices, to perform analytics, and to
                                    measure the performance of our advertising campaigns. Google
                                    Analytics and Advertising. We utilize certain forms of display
                                    advertising and other advanced features through Google
                                    Analytics, such as Remarketing with Google Analytics, Google
                                    Display Network Impression Reporting, the DoubleClick Campaign
                                    Manager Integration, and Google Analytics Demographics and
                                    Interest Reporting. These features enable us to use first-party
                                    cookies (such as the Google Analytics cookie) and third-party
                                    cookies (such as the DoubleClick advertising cookie) or other
                                    third-party cookies together to inform, optimize, and display
                                    ads based on your past visits to the Service. You may control
                                    your advertising preferences or opt-out of certain Google
                                    advertising products by visiting the Google Ads Preferences
                                    Manager, currently available at{" "}
                                    <a href="https://google.com/ads/preferences">
                                        https://google.com/ads/preferences
                                    </a>
                                    , or by visiting NAI’s online resources at
                                    <a href="https://www.networkadvertising.org/choices">
                                        https://www.networkadvertising.org/choices{" "}
                                    </a>
                                    . Some of these opt-outs may not be effective unless your
                                    browser is set to accept cookies. If you delete cookies, change
                                    your browser settings, switch browsers or computers, or use
                                    another operating system, you will need to opt-out again. Please
                                    also note that when you opt out of receiving interest-based
                                    advertisements, this does not mean you will no longer see
                                    advertisements from us or on our online services. We are not
                                    responsible for the effectiveness of, or compliance with, any
                                    third-parties’ opt-out options or programs or the accuracy of
                                    their statements regarding their programs. In addition, third
                                    parties may still use cookies to collect information about your
                                    use of our online services, including for analytics and fraud
                                    prevention as well as any other purpose permitted under each
                                    program’s governing principles.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    Control Over Your Information
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Profile and data sharing settings. You may update your profile
                                    information, such as your user name, and may change some of your
                                    data sharing preferences by emailing us at{" "}
                                    <a href="mailto:info@appbox.cloud">info@appbox.cloud</a>. How to
                                    control your communications preferences. You can stop receiving
                                    promotional email communications from us by emailing us at{" "}
                                    <a href="mailto:info@appbox.cloud">info@appbox.cloud</a>. We
                                    make every effort to promptly process all unsubscribe requests.
                                    You may not opt out of service-related communications (e.g.,
                                    account verification, transactional communications,
                                    changes/updates to features of the Service, technical and
                                    security notices). Modifying or deleting your information. If
                                    you have any questions about reviewing, modifying, or deleting
                                    your information, or if you want to remove your name or comments
                                    from our Service or publicly displayed content, you can contact
                                    us directly at{" "}
                                    <a href="mailto:info@appbox.cloud">info@appbox.cloud</a>. We may
                                    not be able to modify or delete your information in all
                                    circumstances.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    How We Store and Protect Your Information
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Data storage and transfer: We store data on servers in the EU or
                                    any other country in which Appbox or its affiliates,
                                    subsidiaries, agents or contractors maintain facilities. Data
                                    retention: We will retain your information as long as necessary
                                    for the purposes outlined in this Privacy Policy, and for a
                                    commercially reasonable time thereafter for backup, archival,
                                    fraud prevention or detection, or audit purposes, or as
                                    otherwise required by law. We may anonymize and/or aggregate
                                    personal information and store it in order to analyze aggregate
                                    metrics and trends. Keeping your information safe: We care about
                                    the security of your information and employ physical,
                                    administrative, and technological safeguards designed to
                                    preserve the integrity and security of all information collected
                                    through our Service. However, no security system is
                                    impenetrable, and we cannot guarantee the security of our
                                    systems 100%. In the event that any information under our
                                    control is compromised as a result of a breach of security, we
                                    will take reasonable steps to investigate the situation and,
                                    where appropriate, notify those individuals whose information
                                    may have been compromised and take other steps, in accordance
                                    with any applicable laws and regulations.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    Children’s Privacy
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Appbox does not knowingly collect or solicit any information
                                    from anyone under the age of 13 on this Service and the Services
                                    is not targeted towards anyone under the age of 13. If you
                                    believe that we might have received information from a child
                                    under 13, please contact us at
                                    <a href="mailto:info@appbox.cloud">info@appbox.cloud</a>.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    Links to Other Web Sites and Services{" "}
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    The Service may contain links to and from third-party websites
                                    of our business partners, advertisers, and social media sites
                                    and our users may post links to third-party websites. If you
                                    follow a link to any of these websites, please note that these
                                    websites have their own privacy policies and that we do not
                                    accept any responsibility or liability for their policies. We
                                    strongly recommend that you read their privacy policies and
                                    terms and conditions of use to understand how they collect, use,
                                    and share information. We are not responsible for the privacy
                                    practices or the content on the websites of third-party sites.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    How to Contact Us
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                <Text style={{ fontSize: "1.2em" }}>
                                    If you have any questions about this Privacy Policy or the
                                    Service, please contact us at{" "}
                                    <a href="mailto:info@appbox.cloud">info@appbox.cloud</a>.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    Changes to Our Privacy Policy
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    We may modify or update this Privacy Policy from time to time to
                                    reflect the changes in our business and practices, so you should
                                    review this page periodically. When we change the policy in a
                                    material manner, we will notify you by sending a notice to the
                                    primary email address specified in your Appbox account, by
                                    placing a prominent notice on our website or another appropriate
                                    method. We will also update the ‘last modified’ date at the top
                                    of this page. If you object to any changes, you may close your
                                    account.
                                </Text>
                            </Row>
                        </Col>
                        <Col span={4}></Col>
                    </Row>
                </Card>
            </Row>
            <AppFooter />
        </LoginContainer>
    );
};
export { Privacy };
